// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","title":"App_title__YS7Xx","heading":"App_heading__8MFcy","jobs":"App_jobs__xA5BD"};